import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../utils/Common';
import Verifiers from '../../../../utils/Verifiers.jsx';

const NETJETriego = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [filtros, setfiltros] = useState({ fecha: '', valvula: 0, rancho: 0, reporte_riego: 1 });
    const [opciones, setopciones] = useState({ valvulas: [], ranchos: [] });
    const [listaFertilizacion, setlistaFertilizacion] = useState([]);
    const [totales, settotales] = useState({
        "camas_ocupadas": 0,
        "fertilizante_exacto": 0,
        "fertilizante_ceil": 0,
        "evapotranspiracion": null
    });
    var counter = 0;
    useEffect(() => {
        getData(filtros, true)
    }, []);

    const keyGen = () => {
        counter++;
        return counter;
    }

    const getData = async (fil = { ...filtros }, conAnimacionCarga = false) => {
        let resp = await Post('api/general/netjet', fil, 'POST', conAnimacionCarga ? setloader : false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        setopciones({ valvulas: resp.data.valvulas, ranchos: resp.data.ranchos });
        setfiltros({ ...fil, fecha: resp.data.fecha });
        settotales(resp.data.totales);
        setlistaFertilizacion(resp.data.lista);
    }

    const changeValue = (e) => {
        let { name, value } = e.target;
        let fil = { ...filtros, [name]: value };
        setfiltros(fil);
        getData(fil, true);
    }

    const intervalos_camas = (camas) => {
        let camasLista = camas.split(',').map((e) => parseInt(e));
        let intervalos = [[]];
        let indexIntevalos = 0;
        camasLista.forEach(element => {
            let actualIntervaloLen = intervalos[indexIntevalos].length - 1;
            if (intervalos[indexIntevalos].length === 0) intervalos[indexIntevalos].push(element);
            else if (Math.abs(element - intervalos[indexIntevalos][actualIntervaloLen]) != 1) {
                intervalos.push([]);
                indexIntevalos++;
                intervalos[indexIntevalos].push(element);
            } else intervalos[indexIntevalos].push(element);
        });

        camasLista = [];
        intervalos.forEach(element => {
            if (element.length === 1) camasLista.push(element[0]);
            else camasLista.push(element[0] + ' - ' + element[element.length - 1]);
        });
        return camasLista;
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>
                    Reporte de riego (NETJET)
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>FECHA</label>
                    <input
                        type="date"
                        name='fecha'
                        className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center'
                        value={filtros.fecha}
                        onChange={changeValue}
                    />
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>FILTRADO POR RANCHO</label>
                    <select className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center' name='rancho' value={filtros.rancho | ''} onChange={changeValue}>
                        <option value='' >Todos los ranchos</option>
                        {
                            opciones.ranchos.map((rancho, i) => <option key={keyGen()} value={rancho.id}>{rancho.nombre}</option>)
                        }
                    </select>
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>VALVULAS</label>
                    <select className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center' name='valvula' value={filtros.valvula | ''} onChange={changeValue}>
                        <option value='' >Todas las valvulas</option>
                        {
                            opciones.valvulas.map((valvula, i) => <option key={keyGen()} value={valvula.id}>{valvula.rancho} °°° {valvula.nombre}</option>)
                        }
                    </select>
                </div>
                <div className='bw-400 text-center border-bottom'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-25 border-end'>Metros²</div>
                        <div className='w-25 border-end'>Evapt.</div>
                        <div className='w-25 border-end'>Riego</div>
                        <div className='w-25'>Riego max</div>
                        <div className='w-25 border-end border-top text-bold'>{+Verifiers.numberFormat(totales.metros_cuadrados).toFixed(2)}</div>
                        <div className='w-25 border-end border-top text-bold'>{+Verifiers.numberFormat(totales.evapotranspiracion).toFixed(2)}</div>
                        <div className='w-25 border-end border-top text-bold'>{+Verifiers.numberFormat(totales.fertilizante_exacto).toFixed(2)}</div>
                        <div className='w-25  border-top text-bold'>{+totales.fertilizante_ceil.toFixed(2)}</div>
                    </div>
                </div>
                <div className='w-100 mt-2 mb-1' />
                <div className='bw-1200 border-top border-bottom border-secondary p-1' style={{ maxHeight: '80vh' }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {listaFertilizacion.map((valvula, i) =>
                            <div key={keyGen()} className='w-100 bg-white shadow border mt-2 mb-2 p-1 round-s'>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='w-100 round-top-s bg-black p-0 ps-3 text-white text-400 text-l'>
                                        {valvula.rancho}
                                        <span className='ms-2 me-2 text-s text-300'>|</span>
                                        {valvula.valvula}
                                        <span className='ms-2 me-2 text-s text-300'>|</span>
                                        <span className='text-s text-300'>{valvula.largo_cama} m² x cama</span>
                                    </div>

                                    <div className='bw-350 m-0 p-0'>
                                        <div className='w-100 text-center border-bottom border-info round-xs text-l mb-1 mt-1 p-0'
                                            style={{ backgroundColor: "#dcf4ff" }}>
                                            <span className='text-xs text-bold m-0 me-2 p-0'>Riego</span>
                                            {+valvula.fertilizante_exacto.toFixed(2)}
                                            <span className='text-xs text-bold ms-2'>U</span>
                                        </div>
                                    </div>

                                    <div className='bw-150 m-0 p-0'>
                                        <div className='w-100 text-center border-bottom mb-1 mt-1 p-0'>
                                            <span className='text-xs text-bold m-0 me-2 p-0'>metros²</span>
                                            {valvula.metros_cuadrados ?? "0"}
                                        </div>
                                    </div>
                                    <div className='bw-150 m-0 p-0'>
                                        <div className='w-100 text-center border-bottom mb-1 mt-1 p-0'>
                                            <span className='text-xs text-bold m-0 me-2 p-0'>Camas</span>
                                            {valvula.camas_ocupadas ?? "0"}
                                        </div>
                                    </div>

                                    <div className='bw-500 mt-1 mb-1'>
                                        <div className='row justify-content-start'>
                                            <div className='col-auto me-1 text-bold text-xs contenedor'>Grupos de camas:</div>
                                            {intervalos_camas(valvula.camas).map((intervalo, i) =>
                                                <div key={keyGen()} className='col-auto round-m border bg-light shadoe-sm m-0 ms-1 me-1 pt-0 pb-0 mt-1'>{intervalo}</div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default NETJETriego;